import React from 'react';
import styles from './MetricCardsSkeleton.module.css';

const MetricCardsSkeleton: React.FC<{ count?: number }> = ({ count = 4 }) => {
  return (
    <div className={styles.metricsGrid}>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className={styles.metricCard}>
          <div className={styles.metricContent}>
            <div className={styles.metricInfo}>
              <div className={styles.metricValue}></div>
              <div className={styles.metricTitle}></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MetricCardsSkeleton;
